import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row h2 m-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Change Password")
], -1)
const _hoisted_3 = { class: "row text-primary m-4 justify-content-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-sm-2 text-left" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Old Password")
], -1)
const _hoisted_5 = { class: "col-6 col-sm-2" }
const _hoisted_6 = { class: "row text-primary m-4 justify-content-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-sm-2 text-left" }, [
  /*#__PURE__*/_createElementVNode("span", null, " New Password")
], -1)
const _hoisted_8 = { class: "col-6 col-sm-2" }
const _hoisted_9 = { class: "row text-primary m-4 justify-content-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 col-sm-2 text-left" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Confirm Password")
], -1)
const _hoisted_11 = { class: "col-6 col-sm-2" }
const _hoisted_12 = { class: "row h3 text-success" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "Password Changed Successfully", -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "row h3 text-danger" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", null, "Password Could not be Changed", -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "col-12",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.oldPassword) = $event)),
          placeholder: "Enter Old Password"
        }, null, 512), [
          [_vModelText, $setup.oldPassword]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "col-12",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.newPassword) = $event)),
          placeholder: "Enter New Password"
        }, null, 512), [
          [_vModelText, $setup.newPassword]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "col-12",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.confirmPassword) = $event)),
          placeholder: "Confirm New Password"
        }, null, 512), [
          [_vModelText, $setup.confirmPassword]
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("button", {
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.changePassword && $setup.changePassword(...args)))
      }, "Change Password")
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, _hoisted_14, 512), [
      [_vShow, $setup.isPasswordChangeSuccessful == 'true']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_15, _hoisted_17, 512), [
      [_vShow, $setup.isPasswordChangeSuccessful == 'false']
    ])
  ]))
}